export default function HeroGraphic() {
  return (
    <svg viewBox="0 0 640 430" fill="none" className="h-auto w-full" aria-hidden="true">
      <defs>
        <pattern id="dn-grid" width="26" height="26" patternUnits="userSpaceOnUse">
          <path d="M26 0H0v26" fill="none" stroke="#173F3A" strokeOpacity="0.07" />
        </pattern>
        <pattern id="dn-dots" width="11" height="11" patternUnits="userSpaceOnUse">
          <circle cx="2" cy="2" r="1.6" fill="#173F3A" fillOpacity="0.4" />
        </pattern>
      </defs>

      <rect width="640" height="430" fill="url(#dn-grid)" />

      {/* angoli di mirino */}
      <g stroke="#173F3A" strokeOpacity="0.3" strokeWidth="1.4">
        <path d="M30 62 V32 H62" />
        <path d="M578 32 H610 V62" />
        <path d="M610 368 V400 H578" />
        <path d="M62 400 H30 V368" />
      </g>

      {/* etichette */}
      <text x="58" y="66" fontSize="12" fontWeight="600" letterSpacing="3" fill="#173F3A" fillOpacity="0.6" fontFamily="Manrope, sans-serif">
        TUTTA ITALIA
      </text>
      <text x="58" y="86" fontSize="10" letterSpacing="2" fill="#5C646B" fillOpacity="0.6" fontFamily="Manrope, sans-serif">
        42° N · 12° E
      </text>

      {/* area di progetto puntinata */}
      <rect x="220" y="100" width="280" height="170" fill="url(#dn-dots)" stroke="#173F3A" strokeOpacity="0.35" strokeWidth="1.4" />

      {/* cerchio tecnico con croce */}
      <g fill="none" stroke="#173F3A" strokeOpacity="0.45" strokeWidth="1.4">
        <circle cx="140" cy="240" r="36" />
        <path d="M128 240 h24 M140 228 v24" />
      </g>
      <circle cx="140" cy="240" r="3.5" fill="#7A9B8E" />

      {/* collegamenti tecnici a gomito e diagonale precisa */}
      <g fill="none" stroke="#7A9B8E" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round">
        <path d="M176 240 H200 V70 H280 V100" />
        <path d="M531 270 L566 305" />
      </g>

      {/* nodi tecnici */}
      <g fill="#7A9B8E">
        <circle cx="280" cy="100" r="3.5" />
        <circle cx="500" cy="270" r="3.5" />
        <circle cx="566" cy="305" r="3.5" />
      </g>
      <circle cx="280" cy="100" r="9" fill="none" stroke="#7A9B8E" strokeOpacity="0.5" />
      <circle cx="500" cy="270" r="9" fill="none" stroke="#7A9B8E" strokeOpacity="0.5" />

      {/* quadrato ruotato 45° sull'angolo dell'area */}
      <rect
        x="478"
        y="248"
        width="44"
        height="44"
        stroke="#7A9B8E"
        strokeOpacity="0.8"
        strokeWidth="1.4"
        transform="rotate(45 500 270)"
      />

      {/* quota orizzontale */}
      <g stroke="#5C646B" strokeOpacity="0.5" strokeWidth="1">
        <path d="M220 302 v12 M220 308 h280 M500 302 v12" />
      </g>
      <text x="360" y="328" fontSize="11" letterSpacing="1" fill="#5C646B" fillOpacity="0.75" textAnchor="middle" fontFamily="Manrope, sans-serif">
        1:200
      </text>

      {/* quota verticale */}
      <g stroke="#5C646B" strokeOpacity="0.5" strokeWidth="1">
        <path d="M545 100 h-12 M539 100 v170 M545 270 h-12" />
      </g>
    </svg>
  );
}
